import { Box, Flex, Heading, Text, Button, VStack, Toaster, createToaster } from '@chakra-ui/react'
import { Plus, Calendar, Vote, Settings } from 'lucide-react'
import { NavLink, Outlet, useParams } from 'react-router-dom'
import { useState } from 'react'
import { useProperty } from '@/features/properties/hooks/useProperties'
import { MeetingCreateModal } from '../components/MeetingCreateModal'

const toaster = createToaster({
  placement: 'top-end',
  duration: 4000,
})

export { toaster as meetingsToaster }

const NAV_ITEMS = [
  { to: 'list', label: 'Assemblées', icon: Calendar },
  { to: 'council', label: 'Conseil syndical', icon: Vote },
  { to: 'settings', label: 'Paramètres', icon: Settings },
]

export function MeetingsLayout() {
  const { residenceId } = useParams<{ residenceId: string }>()
  const { data: residence, isLoading: residenceLoading } = useProperty(residenceId)
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

  if (residenceLoading) {
    return (
      <Box p={6}>
        <Text>Chargement...</Text>
      </Box>
    )
  }

  if (!residenceId || !residence) {
    return (
      <Box p={6}>
        <Text>Résidence non trouvée</Text>
      </Box>
    )
  }

  return (
    <Box>
      {/* Header */}
      <Flex justify="space-between" align="start" mb={6}>
        <Box>
          <Heading size="xl" mb={1}>
            Assemblées Générales
          </Heading>
          <Text color="gray.600">{residence.name}</Text>
        </Box>
        <Button colorPalette="brand" onClick={() => setIsCreateModalOpen(true)}>
          <Plus size={16} />
          Nouvelle AG
        </Button>
      </Flex>

      {/* Navigation tabs */}
      <Flex
        gap={0}
        mb={6}
        borderBottom="1px solid"
        borderColor="gray.200"
        overflowX="auto"
      >
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            style={{ textDecoration: 'none' }}
          >
            {({ isActive }) => (
              <Flex
                align="center"
                gap={2}
                px={4}
                py={3}
                color={isActive ? 'brand.600' : 'gray.600'}
                borderBottom="2px solid"
                borderColor={isActive ? 'brand.600' : 'transparent'}
                fontWeight={isActive ? 'semibold' : 'normal'}
                _hover={{ color: 'brand.600', bg: 'gray.50' }}
                transition="all 0.2s"
                whiteSpace="nowrap"
              >
                <Icon size={16} />
                <Text fontSize="sm">{label}</Text>
              </Flex>
            )}
          </NavLink>
        ))}
      </Flex>

      {/* Content */}
      <Outlet />

      {/* Modal création AG */}
      <MeetingCreateModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        residenceId={residenceId}
      />

      {/* Toaster */}
      <Toaster toaster={toaster}>
        {(toast) => (
          <Box
            bg={toast.type === 'success' ? 'green.500' : toast.type === 'error' ? 'red.500' : 'blue.500'}
            color="white"
            p={4}
            borderRadius="md"
            boxShadow="lg"
          >
            <VStack align="start" gap={1}>
              {toast.title && <Text fontWeight="bold">{toast.title}</Text>}
              {toast.description && <Text fontSize="sm">{toast.description}</Text>}
            </VStack>
          </Box>
        )}
      </Toaster>
    </Box>
  )
}
